/**
 * Asynchronously loads the component for MyClass
 */
import Loadable from "react-loadable";

export default Loadable({
  loader: () => import("."),
  loading: () => null
});
